import { useEffect, useState } from "react";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SpanRender } from "../../../theme/Component/SpanRender";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";

interface Props {
    typeQuestion: number;
    options: any;
    onChange: any;
    requireAnswer?: boolean;
}
export const ViewQuestionItem = ({ typeQuestion, options, onChange, requireAnswer }: Props) => {


    const UNIQUE = 1; // unica respuesta
    const MULTIPLE = 2; // multiple respuesta
    const BOOLEAN = 3; // verdadero / falso
    const OPEN = 4; // pregunta abierta

    const [openQuestion, setOpenQuestion] = useState<string>('');
    const [trueAnswer, setTrueAnswer] = useState<boolean>(undefined);
    const [jsutifica, setJustifica] = useState<string>('');
    const [uniqueAnswer, setUniqueAnswer] = useState<number>(undefined);
    const [multipleAnswer, setMultipleAnswer] = useState<any>([]);
    const uniqueKey = _single.getRandomInt();

    useEffect(() => {

        if (onChange) {
            if (typeQuestion === UNIQUE)
                onChange(uniqueAnswer);
            if (typeQuestion === MULTIPLE)
                onChange(multipleAnswer);
            if (typeQuestion === BOOLEAN)
                onChange({
                    option:trueAnswer,
                    justifica:jsutifica
            });
            if (typeQuestion === OPEN)
                onChange(openQuestion);
        }


    }, [trueAnswer, uniqueAnswer, multipleAnswer, openQuestion,jsutifica])

    return (
        <div className="row">
            <div className="col-md-12">
                {typeQuestion === OPEN &&
                    <>
                        <label>Deje Sus Comentarios</label>
                        <textarea className="form-control" name="obs" id="obs" value={openQuestion} onChange={(e) => { setOpenQuestion(e.target.value) }} ></textarea>
                    </>
                }
                {typeQuestion === BOOLEAN &&
                    <>
                        <ul>
                            <li style={{ listStyle: 'none' }}>
                                <div className="d-flex">
                                    <div>
                                        <input
                                            type="radio"
                                            value="true"
                                            name={`q_${uniqueKey}`}
                                            checked={trueAnswer === true}
                                            onChange={() => {setTrueAnswer(true);setJustifica('')}}
                                        />
                                    </div>
                                    <div style={{ marginLeft: 10 }}>
                                        SI
                                    </div>
                                </div>
                            </li>
                            <li style={{ listStyle: 'none' }}>
                                <div className="d-flex">
                                    <div>
                                        <input
                                            type="radio"
                                            value="false"
                                            name={`q_${uniqueKey}`}
                                            checked={trueAnswer === false}
                                            onChange={() => {setTrueAnswer(false);setJustifica('')}}
                                        />
                                    </div>
                                    <div style={{ marginLeft: 10 }}>
                                        NO
                                    </div>
                                </div>
                            </li>
                        </ul>
                        {(requireAnswer && trueAnswer === true) &&
                            <>
                                <label>Justifique la respuesta</label>
                                <textarea name="jus" className="form-control" placeholder="Por favor describa su respuesta" value={jsutifica} onChange={(e)=>{setJustifica(e.target.value)}} ></textarea>
                            </>
                        }
                    </>
                }
                {typeQuestion === UNIQUE &&
                    <>
                        {options &&
                            <ul >
                                {options.map((item, index) => {
                                    return (
                                        <li key={index} style={{ listStyle: 'none' }}>
                                            <div className="d-flex">
                                                <div>
                                                    <input type="radio" value={item.DataBeanProperties.IDQuestionItems} name={`q_${uniqueKey}`} onChange={(e) => { setUniqueAnswer(parseInt(e.target.value)) }} />
                                                </div>
                                                <div style={{ marginLeft: 10 }}>
                                                    <SpanRender value={item.DataBeanProperties.OptionText} />
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        }
                    </>
                }
                {typeQuestion === MULTIPLE &&
                    <>
                        {options &&
                            <ul >
                                {options.map((item, index) => {
                                    return (
                                        <li key={index} style={{ listStyle: 'none' }}>
                                            <div className="d-flex">
                                                <div>
                                                    <input
                                                        type="checkbox"
                                                        value={item.DataBeanProperties.IDQuestionItems}
                                                        checked={multipleAnswer.includes(item.DataBeanProperties.IDQuestionItems)}
                                                        onChange={(e) => {
                                                            const id = parseInt(e.target.value);
                                                            if (e.target.checked) {
                                                                // Agregar si no está
                                                                if (!multipleAnswer.includes(id)) {
                                                                    setMultipleAnswer([...multipleAnswer, id]);
                                                                }
                                                            } else {
                                                                // Eliminar si está
                                                                setMultipleAnswer(multipleAnswer.filter((val) => val !== id));
                                                            }
                                                        }}
                                                    />
                                                </div>
                                                <div style={{ marginLeft: 10 }}>
                                                    <SpanRender value={item.DataBeanProperties.OptionText} />
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        }
                    </>
                }
            </div>
                    {/* <div className="col-md-12">
                        <PrintJson json={options} />
                    </div> */}
        </div>
    )
}